import { employeeTableDisplay } from "../../../../config/headcountConfigs";

let columnsRenderFunctions = {};
columnsRenderFunctions['status'] = require('./renderStatus').default;
employeeTableDisplay.filter(item => item !== 'status' ).forEach(item => {
    columnsRenderFunctions[item] = require('./useRenderFilters').default;
})
export default columnsRenderFunctions;